import React from 'react'
import '../styles/Footer/footer.css';

function Footer() {
  return (
    <div className='footer'>
        <div className='footer-inner'>
            <h5>Sample text. Click to select the text box. Click again or double click to start editing the text.</h5>
            <a href='www.google.com'>Template created by Jeral Sandeeptha</a>
        </div>
    </div>
  )
}

export default Footer
